import { render, staticRenderFns } from "./jobManagement.vue?vue&type=template&id=ddc09eb2&scoped=true"
import script from "./jobManagement.vue?vue&type=script&lang=js"
export * from "./jobManagement.vue?vue&type=script&lang=js"
import style0 from "./jobManagement.vue?vue&type=style&index=0&id=ddc09eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc09eb2",
  null
  
)

export default component.exports